/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import about from './de/about.json';
import admin from './de/admin.json';
import cluster from './de/cluster.json';
import common from './de/common.json';
import confirmationPage from './de/confirmation-page.json';
import createCluster from './de/create-cluster.json';
import createOrganization from './de/create-organization.json';
import createProject from './de/create-project.json';
import entities from './de/entities.json';
import general from './de/general.json';
import login from './de/login.json';
import navigation from './de/navigation.json';
import organizationAdmin from './de/organization-admin.json';
import project from './de/project.json';
import rbac from './de/rbac.json';
import setup from './de/setup.json';
import userProfile from './de/user-profile.json';
import validation from './de/validation.json';
import { findCountryLocalizations } from './index';

export const deTranslation = {
  about,
  admin,
  cluster,
  common,
  confirmationPage,
  countries: findCountryLocalizations('de'),
  createCluster,
  createOrganization,
  createProject,
  entities,
  general,
  login,
  navigation,
  organizationAdmin,
  project,
  rbac,
  setup,
  userProfile,
  validation,
};
